import { Button } from 'reactstrap';
import {
  useCloseOldModal,
  useSetUnmountModalCallback,
} from '../../../../../store/modal/modalHooks';
import { useTranslation } from 'react-i18next';
import './purchase-subscription-form-actions.scss';

type Props = {
  onPurchaseSubscription: () => Promise<void>;
};

const PurchaseSubscriptionFormActions = ({ onPurchaseSubscription }: Props) => {
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();
  const setUnmountModalCallback = useSetUnmountModalCallback();

  const onCloseModal = () => {
    setUnmountModalCallback(undefined);
    closeModal();
  };

  return (
    <div className="purchase-subscription-form-actions">
      <Button
        className="confirm-purchase-subscription-button"
        type="button"
        onClick={onPurchaseSubscription}
        color="primary"
      >
        {t('PURCHASE_SUBSCRIPTION')}
      </Button>
      <Button
        className="cancel-purchase-subscription-button"
        type="button"
        color="transparent"
        onClick={onCloseModal}
      >
        {t('CLOSE_BUTTON')}
      </Button>
    </div>
  );
};

export default PurchaseSubscriptionFormActions;
